import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { I18nProvider } from "@/i18n";
import { SiteHeader } from "@/components/SiteHeader";
import { SiteFooter } from "@/components/SiteFooter";
import Landing from "@/components/Landing";
import Studio from "@/pages/Studio";
import LegalPage from "@/pages/LegalPage";

export default function App() {
  return (
    <I18nProvider>
      <BrowserRouter>
        <SiteHeader />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/studio" element={<Studio />} />
          <Route path="/legal" element={<LegalPage doc="legal" />} />
          <Route path="/privacy" element={<LegalPage doc="privacy" />} />
        </Routes>
        <SiteFooter />
        <Toaster theme="dark" position="bottom-right" />
      </BrowserRouter>
    </I18nProvider>
  );
}
